import React, { FC } from 'react';
import { serverSideTranslation } from '../util/next';
// import { useTranslation } from 'next-i18next';

import Page from '../components/Layout/Page';
import MediaCard from '../components/MediaCard';
import { getPageContent } from '../api/pagesApi';

import { genShareConfig } from '../components/Share/use-config-share';

interface Props {
  pageContentData: any;
}

const Media: FC<Props> = (props) => {
  const { pageContentData } = props;
  const { pageContent = {}, shareContent = {} } = pageContentData || {};
  const { mediaTitle, mediaIntro, mediaContact, mediaDownTitle } = pageContent;
  const mediaDownList = pageContent.mediaDownList as [];
  // const { t } = useTranslation('media');
  // const mediaTitle = t('mediaTitle');
  // const mediaIntro = t('mediaIntro');
  // const mediaContact = t('mediaContact');
  // const mediaDownTitle = t('mediaDownTitle');
  // const mediaDownList: [] = t('mediaDownList', { returnObjects: true });

  const mediaBg = 'https://p0.meituan.net/smartvenus/4d20c8b2bf8a5d951b0a8c0049337634402543.png';
  const style = {
    backgroundImage: `url(${mediaBg})`,
  };

  return (
    <Page title={shareContent.shareTitle}>
      <div className="bg-cover bg-center bg-no-repeat" style={style}>
        <div className="m-auto max-w-screen-xl px-5 lg:pb-30">
          {/* 媒体资源标题 */}
          <div className="mt-font pb-3 pt-20 text-xl font-medium leading-none text-black-dark lg:pb-4 lg:pt-32 lg:text-4.5xl">
            {mediaTitle}
          </div>
          <div className="flex flex-col text-xs text-black-65 lg:flex-row lg:text-sm">
            <div>{mediaIntro}</div>
            <div>{mediaContact}</div>
          </div>
          <div className="mb-3 mt-8 text-lg font-medium leading-none text-black lg:mb-5 lg:mt-10 lg:text-2sm">
            {mediaDownTitle}
          </div>
          <div className="grid h-auto grid-cols-2 gap-3 pb-15 lg:grid-cols-4 lg:gap-5">
            {mediaDownList?.map((item, index) => {
              return <MediaCard MediaCardData={item} key={index} />;
            })}
          </div>
        </div>
      </div>
    </Page>
  );
};

export async function getServerSideProps({ locale, query }: any) {
  const pageContentParams = {
    uri: '/media',
    pageContentNo: query.pageContentNo,
    preview: query.preview,
  };
  const pageContentData = await getPageContent(pageContentParams, locale);
  return {
    props: {
      lxCustom: {
        cid: 'c_donation_bazfymnt',
        locale,
        ...pageContentData?.shareContent,
      },
      pageContentData,
      ...genShareConfig(pageContentData),
      ...(await serverSideTranslation(locale, ['media', 'cookie', 'common'])),
    },
  };
}

export default Media;
